export enum PAD_DRILLING_STATUS {
  drilled = 'drilled',
  planned = 'planned',
  unplanned = 'unplanned',
  updated = 'updated',
}
